// src/components/ThemeLoader.js
import { useEffect } from "react";
import { getData } from "../../utils/localStorage/LocalStorageHandler";


const loadTheme = (themeCode) => {
  let link = document.getElementById("app-theme");
  if (!link) {
    link = document.createElement("link");
    link.id = "app-theme";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://unpkg.com/primereact/resources/themes/${themeCode}/theme.css`;
};

const ThemeLoader = () => {
  useEffect(() => {
    const savedTheme = getData("app-theme") || "lara-light-blue"; // default
    loadTheme(savedTheme);
  }, []);

  return null; // no UI
};

export default ThemeLoader;

